import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngxs/store';
import { ErrorService, ErrorMessage } from 'src/app/shared/error.service';
import { WidgetState } from 'src/app/widget-auth/state/widget.state';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-https-validation',
  templateUrl: './https-validation.component.html',
  styleUrls: ['./https-validation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HttpsValidationComponent implements OnInit, OnDestroy {

  message = `It looks like you are trying to load the BioDigital Human on an insecure (http://) site.
  Try reloading the page as https:// or contact your website administrator.`;

  @Input()
  url: string;

  shown: boolean;

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private errorService: ErrorService
  ) { }

  ngOnInit() {
    this.initValidation();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initValidation() {
    this.shown = this.isHTTP(this.url);
    if (this.shown) {
      this.handleHTTPInsecure();
    }
  }

  handleDismissClick() {
    this.shown = false;
  }

  handleHTTPInsecure() {
    const url = this.store.selectSnapshot(WidgetState.getParentURL);
    const errorMessage: ErrorMessage = {
      category: 'WIDGET_INSECURE_HTTP',
      message: `Invalid protocol [HTTP] for hosting site: ${url}`
    };

    // log error
    this.errorService.logError(errorMessage)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();

    // warn user
    console.warn(this.message);
  }

  isHTTP(url: string) {
    // extract protocol from URL
    const match = url.match(/^[^:]+/);
    if (match && match.length) {
      const protocol = match[0];
      // return if explicitly HTTP
      return protocol === 'http';
    } else {
      return false;
    }
  }

}
